<template>
  <div>
    <div class="header">
      <div class="header-wrap container clearfix">
        <a class="logo fl">
          <img src="../../assets/img/logo.png" alt />
        </a>
        <div class="web_name">
          <div class="zh_name">日照教育云</div>
          <div class="website_name"></div>
        </div>
        <div class="header-regist-wrap fl"></div>
        <!-- <a href="http://www.91cb.net/" class="logo fl">
          <img src="../../assets/img/logo.png" alt />
        </a> -->
        <!-- <div class="header-regist-wrap fl">
          <a href="javascript:;" class="header-regist">登录</a>
        </div> -->
        <div class="header-btn fr" style="display: none">
          <span class="existing">已有账号</span>
        </div>
      </div>
    </div>

    <div class="login-wrap">
      <div class="login-container">
        <div class="login-box" style="height: 350px">
          <h1 class="title">账户登录</h1>
          <input
            type="text"
            v-model="form.userid"
            class="input-num common"
            placeholder="账号/手机号"
          />
          <input
            type="password"
            class="input-code common"
            v-model="form.password"
            placeholder="密码"
          />
          <input
            type="text"
            v-model="form.code"
            class="input-num common"
            style="width: 150px; position: relative; left: -25px"
            placeholder="请输入验证码"
          /><img
            :src="imgUrl"
            @click="flushImg"
            style="position: relative; top: 10px"
          />
          <div id="login" style="margin-top: 10px">
            <a href="javascript:;" class="btn common" @click="formSubmit"
              >登录</a
            >
          </div>
          <div class="msg-box clearfix">
            <a @click="goPassport()" class="forget-btn fl">忘记密码?</a>
            <a @click="goRegister()" class="regist-btn fr">立即注册</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
export default {
  data() {
    return {
      flag: false,
      form: {
        userid: "",
        password: "",
        code: "",
      },
      imgUrl: "",
    };
  },
  created() {
    this.imgUrl =
      globalApi.GetWebHost("private-api") +
      '/securityCode.php?temp="' +
      new Date().getTime().toString(36);
    if (window.location.href.indexOf("91cb") != -1) {
      this.flag = true;
    } else {
      this.flag = false;
    }
    globalApi.GetWebInfoAndUserSessionInfoFromServer(false);
  },
  methods: {
    flushImg() {
      this.imgUrl =
        globalApi.GetWebHost("private-api") +
        '/securityCode.php?temp="' +
        new Date().getTime().toString(36);
    },
    async formSubmit() {
      if (this.form.userid == false) {
        this.$message.error("请输入账号!");
        return false;
      }
      if (this.form.password == false) {
        this.$message.error("请输入密码!");
        return false;
      }
      if (this.form.code == false) {
        this.$message.error("请输入验证码!");
        return false;
      }
      const data = {
        s: "Common.Account.loginByPassword",
        loginuserid: this.form.userid,
        password: this.form.password,
        code: this.form.code,
      };
      const response = await globalApi.post(data);
      const res = response.data.data;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }
      if (res.result == 1) {
        const objectPath = localStorage.getItem("objectPath");
        if (objectPath) {
          location.href = objectPath;
        } else {
          if (res.userAuth.is_student == true) {
            location.href =
              globalApi.GetWebHost("student") + "home?userid=" + res.userid;
          } else if (res.userAuth.is_teach_researcher == true) {
            location.href =
              globalApi.GetWebHost("researcher") + "home?userid=" + res.userid;
          } else if (res.userAuth.is_teacher == true) {
            location.href =
              globalApi.GetWebHost("teacher") + "home?userid=" + res.userid;
          } else {
            location.href = "http://www.rzjyyun.com/";
          }
        }
      } else {
        this.imgUrl =
          globalApi.GetWebHost("private-api") +
          '/securityCode.php?temp="' +
          new Date().getTime().toString(36);
        this.$message.error(res.msg);
      }
    },

    // 跳转注册页面
    goRegister() {
      window.open(globalApi.GetWebHost("reg"), "_blank");
    },
    goPassport() {
      location.href = globalApi.GetWebHost("passport");
    },
  },
};
</script>
<style>
@import "../../assets/css/login_main.css";
</style>
<style lang="scss" scoped>
.web_name {
  margin: auto 10px;
  width: 50%;
  .zh_name {
    position: relative;
    top: 30px;
    left: -20px;
    height: 43px;
    color: #d40a0a;
    font-size: 34px;
    font-weight: 600;
    letter-spacing: 6px;
    text-shadow: 0 0 3px #fff, 0 0 3px #fff, 0 0 3px #fff, 0 0 3px #fff,
      0 0 3px #fff, 0 0 3px #fff, 0 0 3px #fff;
  }
  .website_name {
    height: 22px;
    opacity: 0.8;
  }
}
</style>